// Both screens request one server page of device status records.
export const deviceStatusReportUrl = (domain, { startDate, endDate, companyId, page, pageSize, includeCompany = true }) => {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
    company_id: companyId == null || String(companyId) === "99999" ? "" : companyId,
    page: String(page),
    page_size: String(pageSize),
  });
  if (!includeCompany) params.delete("company_id");
  return `${domain}team_zone/reports/device-status/?${params}`;
};
